/**
 * ForecastStatus
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { FiCheckCircle, FiMinusCircle } from 'react-icons/fi';

// Selectors
import { makeSelectQuantityForecastValue } from '../../../../../../../../../../services/quantityForecasts/selectors';

interface Props {
    actualForecastId?: number;
}

export class ForecastStatus extends React.PureComponent<Props> {
    render() {
        const { actualForecastId } = this.props;
        if (actualForecastId) {
            return (
                <FiCheckCircle
                    size={22}
                    className="text green"
                    style={{ verticalAlign: 'middle' }}
                />
            );
        }
        return (
            <FiMinusCircle
                size={22}
                className="text pink"
                style={{ verticalAlign: 'middle' }}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector({
    actualForecastId: makeSelectQuantityForecastValue('id')
});

export default connect(mapStateToProps)(ForecastStatus);
